module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MN - Mongolia.a86aaa9f.svg";